import CardCommon from '../CardCommon';

export default function CardB() {
    return (
        <>
            <CardCommon
                dirType="imgr"
                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1716172706540/V1.mp4"
                isVideo={true}  
                subTitle="Smart Monitoring & Auto-Savings"
                title="Savings just roll on in"
                desc="Automatically leverage stored power during peak rate hours to significantly reduce your energy costs. Our app continuously monitors rate fluctuations and adjusts usage to ensure you save money. Check the dashboard anytime to see your savings in real time, giving you full visibility and control over your energy expenditures."
            />
        </>
    );
}
